export const weekDays = [0, 1, 2, 3, 4, 5, 6];

export const DAY_LAST_MINUTE = 1439;
